import { render, staticRenderFns } from "./RiskManagement.vue?vue&type=template&id=b051b48c&scoped=true"
import script from "./RiskManagement.vue?vue&type=script&lang=js"
export * from "./RiskManagement.vue?vue&type=script&lang=js"
import style0 from "./RiskManagement.vue?vue&type=style&index=0&id=b051b48c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b051b48c",
  null
  
)

export default component.exports